export default "__VITE_ASSET__DIPaPxlo__"